import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getContrastingColor, getLocalUTCDate, getStartOfMonthTimestamp, getStorageData } from '../../helpers';
import { Select } from '../../components/Select';
import { ADVERT_CITY_STORAGE_NAME, createHandlerWithStorage } from '../../helpers/localStorage';
import { Button } from '../../components/Button';
import { ReturnFlyersPopup } from './ReturnFlyersPopup';
import { RouteCommentPopup } from './RouteCommentPopup';
import { AdvertMonthSwitcher } from './AdvertMonthSwitcher';
import sortImg from '../../assets/sort/sort.png';
import sortDarkImg from '../../assets/sort/sort-dark.png';

const isIdentityReturnedCount = (givenFlyersCount) => {
    let count = givenFlyersCount[0].returnedCount;
    for (let i = 1; i < givenFlyersCount.length; i++) {
        if (givenFlyersCount[i].returnedCount !== count) return false;
    }
    return true;
}
const getGivenFlyersAmount = (givenFlyersCount) => {
    let count = givenFlyersCount[0].count;
    let isIdentity = true;
    for (let i = 1; i < givenFlyersCount.length; i++) {
        if (givenFlyersCount[i].count !== count) {
            isIdentity = false;
            break;
        }
    }
    return isIdentity ? count : givenFlyersCount.map((fc) => fc.count).join(', ')
}

const ResultItem  = ({promoter, comment, isNatural, openReturnPopup, openCommentPopup, isFinishedRoute, bet, sourceType, givenFlyersCount, city, date, route}) => {

    const givenCount = getGivenFlyersAmount(givenFlyersCount);
    const isIdentReturnCount = isIdentityReturnedCount(givenFlyersCount);

    return (
        <div className="given-flyers__item">
            <div>{getLocalUTCDate(city.UTC, date)}</div>
            <div>{sourceType.name}</div>
            <div className='given-flyers__item-flyer'>
                {givenFlyersCount.map(f => <span key={f.flyer._id} style={{backgroundColor: f.flyer.details.backgroundColor, color: getContrastingColor(f.flyer.details.backgroundColor)}}>{f.flyer.name}</span>)}
            </div>
            <div>(id{promoter.id}) {promoter.fullname}</div>
            <div>{promoter.phoneNumber || 'номер скрыт'}</div>
            <div>#{route.id}</div>
            <div title={givenCount}>{givenCount}</div>
            <div>{bet}</div>
            <div className={`given-flyers__item-return ${isFinishedRoute && isNatural ? 'finished':''}`}>
                <div>
                    {givenFlyersCount.map((fc, index) => (isIdentReturnCount && !index) || !isIdentReturnCount ? 
                    <span style={{
                        fontWeight: !isNatural || fc.returnedCount+fc.realSpreadCount === fc.count ? 'bold':'normal',
                        color: !isNatural || fc.returnedCount+fc.realSpreadCount === fc.count ? 'green':fc.returnedCount?'yellow':'red'
                    }}
                    key={fc.flyer._id}>
                        {fc.returnedCount}{!isIdentReturnCount&&index!==givenFlyersCount.length-1?', ':''}
                    </span> : null)}
                </div>
                <Button text='Вернуть' onClick={openReturnPopup}/>
            </div>
            <div className='given-flyers__item-comment finished'>
                <div>{comment || null}</div>
                <Button text='Указать' onClick={openCommentPopup}/>
            </div>
        </div>
    );
};

function parseItemsFromActiveRoutes(promoters, advertSources, mainUTCStr) {
    const list = [];
    promoters.forEach((prom) => {
        const promoter = {_id: prom._id, fullname: prom.fullname, id: prom.id, phoneNumber: prom.phoneNumber || 'Телефон скрыт'};
        const mailboxCount = prom.currentRoute.progress.reduce((total, cur) => total + cur.mailboxCount, 0);
        list.push({
            city: prom.city,
            finishId: 'null',
            promoter,
            route: {_id: prom.currentRoute._id, id: prom.currentRoute.id},
            mailboxCount,
            sourceType: prom.routes.length ? advertSources.find(s => !s.isPrimary) : prom.sourceType,
            givenFlyersCount: prom.currentRoute.givenFlyersCount,
            date: prom.currentRoute.assigned.at,
            bet: prom.currentRoute.bet,
            timestamp: getStartOfMonthTimestamp(new Date(prom.currentRoute.assigned.at), mainUTCStr),
            comment: prom.currentRoute.comment,
        });
        prom.routeQueue.forEach(rq => {
            list.push({
                city: prom.city,
                finishId: 'null',
                promoter,
                route: {_id: rq._id, id: rq.id},
                mailboxCount,
                sourceType: advertSources.find(s => !s.isPrimary),
                givenFlyersCount: rq.givenFlyersCount,
                date: rq.assigned.at,
                bet: rq.bet,
                timestamp: getStartOfMonthTimestamp(new Date(rq.assigned.at), mainUTCStr),
                comment: rq.comment,
            });
        })
    });

    return list;
}

export const GivenFlyers = ({ cities, promoters, months }) => {
    const dispatch = useDispatch();
    const mainUTCStr = useSelector((state) => state.settings.mainUTC);
    const givenFlyersList = useSelector((state) => state.advert.givenFlyers);
    const advertSources = useSelector((state) => state.settings.advertSources);

    const [city, setCity] = useState(getStorageData(cities, ADVERT_CITY_STORAGE_NAME));
    const setCityHandler = createHandlerWithStorage(setCity, ADVERT_CITY_STORAGE_NAME);

    const activeProms = promoters.filter((p) => p.currentRoute._id && p.city._id === city);
    const activeRoutes = parseItemsFromActiveRoutes(activeProms, advertSources, mainUTCStr);

    const thisGivenFlyers = givenFlyersList.filter(f => f.city._id === city);
    const activeMonth = months.find(m => m.active);
    const isLastMonth = activeMonth.timestamp === months[months.length-1].timestamp;
    const thisMonthGivenFlyers = thisGivenFlyers.filter(gf => gf.timestamp === activeMonth.timestamp);

    const itemsList = [...thisMonthGivenFlyers, ...(isLastMonth ? activeRoutes : [])].sort((a,b) => b.date - a.date)

    const [returnPopupId, setReturnPopupId] = useState(null);
    const [commentPopup, setCommentPopup] = useState({prom: null, route: null, finish: null});

    const closeCommentPopup = () => {
        setCommentPopup({prom:null,route:null,finish:null})
    }

    const isLightTheme = useSelector(state => state.app.isLightTheme);
    const [sort, setSort] = useState({type: 'date', isASC: false});
    const setSortHandler = (type) => {
        if (sort.type === type) {
            setSort(prev => ({...prev, isASC: !sort.isASC}));
            return;
        }
        setSort({type, isASC: false})
    }
    const tableHeaders = [
        {type:"date", label: 'Дата'}, {type:"source", label: 'Источник'},
        {type:"flyers", label: 'Листовки'}, {type:"promoter", label: 'Промоутер'},
        {type:"phone", label: 'Телефон прома'}, {type:"route", label: 'Маршрут'},
        {type:"given", label: 'Выдано'}, {type:"bet", label: 'Ставка'},
        {type:"return", label: 'Вернул'}, {type:"comment", label: 'Коммент'}
    ]
    
    const TableTitle = ({type, label}) => {
        const isSortByThis = sort.type === type;
        const isASC = sort.isASC;
        return (
            <div onClick={() => setSortHandler(type)} style={{cursor: 'pointer', userSelect: 'none'}}>
                {label}
                {isSortByThis && <img src={isLightTheme ? sortImg : sortDarkImg} style={{transform: `rotate(${isASC?180:0}deg)`}} alt="" />}
            </div>
        )
    }
    const createSortFn = ({type, isASC}) => {
        switch (type) {
            case 'date': return (a, b) => isASC ? b.date - a.date : a.date - b.date;
            case 'source': return (a, b) => isASC ? b.sourceType.name.localeCompare(a.sourceType.name) : a.sourceType.name.localeCompare(b.sourceType.name);
            case 'flyers': return ((a, b) => isASC ? b.givenFlyersCount.length - a.givenFlyersCount.length : a.givenFlyersCount.length - b.givenFlyersCount.length);
            case 'promoter': return (a, b) => isASC ? b.promoter.fullname.localeCompare(a.promoter.fullname) : a.promoter.fullname.localeCompare(b.promoter.fullname);
            case 'phone': return (a, b) => isASC ? b.promoter.phoneNumber.localeCompare(a.promoter.phoneNumber) : a.promoter.phoneNumber.localeCompare(b.promoter.phoneNumber);
            case 'route': return (a, b) => isASC ? b.route.id - a.route.id : a.route.id - b.route.id;
            case 'given': return (a, b) => isASC ? b.givenFlyersCount[0].count - a.givenFlyersCount[0].count : a.givenFlyersCount[0].count - b.givenFlyersCount[0].count;
            case 'bet': return (a, b) => isASC ? b.bet - a.bet : a.bet - b.bet;
            case 'return': return (a, b) => true;
            case 'comment': return (a, b) => isASC ? b.comment.localeCompare(a.comment) : a.comment.localeCompare(b.comment);
            default: return () => true;
        }
    }
    const sortedList = [...itemsList].sort(createSortFn(sort));

    const givenFlyerItems = sortedList.map((l) => 
        <ResultItem key={`${l.promoter._id}_${l.route.id}_${l.date}`} city={l.city} 
        comment={l.comment} promoter={l.promoter} isNatural={l.isNatural} isFinishedRoute={l.isFinishedRoute} openReturnPopup={() => setReturnPopupId(l.routeId)}
        openCommentPopup={() => setCommentPopup(l.isFinishedRoute ? {prom:null,route:null,finish:l.finishId}:{prom:l.promoter._id,route:l.route._id,finish:null})}
        mailboxCount={l.mailboxCount} sourceType={l.sourceType} route={l.route} date={l.date} timestamp={l.timestamp} givenFlyersCount={l.givenFlyersCount} bet={l.bet}
    />);
    const totalGivenCounts = itemsList.map(item => item.givenFlyersCount.map(fc => ({name: fc.flyer.name, count: fc.count})))
    const totalInWorkCount = activeRoutes.map(item => item.givenFlyersCount.map(fc => ({name: fc.flyer.name, count: fc.count})))
    const fcountMap = new Map();
    const flyersInWorkMap = new Map();
    totalGivenCounts.forEach(gc => {
        gc.forEach(f => {
            try {
                const thisFlyerCount = fcountMap.get(f.name);
                if (thisFlyerCount) {
                    fcountMap.set(f.name, thisFlyerCount + f.count)
                } else {
                    fcountMap.set(f.name, f.count)
                }
            } catch (error) {
                console.log(error)
                console.log(gc, f)
            }
        })
    })
     totalInWorkCount.forEach(gc => {
        gc.forEach(f => {
            try {
                const thisFlyerCount = flyersInWorkMap.get(f.name);
                if (thisFlyerCount) {
                    flyersInWorkMap.set(f.name, thisFlyerCount + f.count)
                } else {
                    flyersInWorkMap.set(f.name, f.count)
                }
            } catch (error) {
                console.log(error)
                console.log(gc, f)
            }
        })
    })
    const totalGivenCountText = Array.from(fcountMap.entries()).map(([name, count]) => `${name}: ${count.toLocaleString('fr-FR')}`).join(' | ')
    const totalInWorkCountText = Array.from(flyersInWorkMap.entries()).map(([name, count]) => `${name}: ${count.toLocaleString('fr-FR')}`).join(' | ')
    return (
        <div className="given-flyers">
            {returnPopupId && <ReturnFlyersPopup data={thisGivenFlyers.find(f => f.finishId === returnPopupId)} routeId={returnPopupId} closeFn={() => setReturnPopupId(null)} />}
            {(!!commentPopup.prom || !!commentPopup.finish) && <RouteCommentPopup routeData={commentPopup} data={commentPopup.finish? thisGivenFlyers.find(f => f.finishId === commentPopup.finish) : activeRoutes.find(f => f.route._id === commentPopup.route && f.promoter._id === commentPopup.prom)} closeFn={closeCommentPopup} />}
            <div className="container">

                <div className="given-flyers__manager">
                    <div className="given-flyers__select-city">
                        <Select
                            enums={cities}
                            value={city}
                            changeHandler={(e) => setCityHandler(e.target.value)}
                        />
                    </div>
                    <div className="given-flyers__total-flyers">
                        <p>Всего выдано: {totalGivenCountText}<span style={{marginLeft: '24px'}}>Всего в работе: {totalInWorkCountText}</span></p>
                    </div>
                </div>
                <div className="given-flyers__body">
                    <div className="given-flyers__table">
                        <div className="given-flyers__titles">
                            {tableHeaders.map(th => <TableTitle key={th.type} type={th.type} label={th.label}/>)}
                        </div>
                        {givenFlyerItems}
                    </div>
                </div>
                <div className="given-flyers__footer">
                    <AdvertMonthSwitcher months={months} />
                </div>
            </div>
        </div>
    );
};
